import { render, staticRenderFns } from "./DamageType.vue?vue&type=template&id=8a4b1318&scoped=true"
import script from "./DamageType.vue?vue&type=script&lang=ts"
export * from "./DamageType.vue?vue&type=script&lang=ts"
import style0 from "./DamageType.vue?vue&type=style&index=0&id=8a4b1318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4b1318",
  null
  
)

export default component.exports